import api from "./api";


export const getPorts = async() => {
    
    try {
        
        let response = await api.get('/get-port-list');
        
        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occured'
            }
        }
        // return response;
        
    } catch (error) {
        console.log(error);
        
        return {
            status: false,
            message: error
        }
        // console.log(error.response.data);
        
        
    }
    
}

export const getScanners = async() => {
    
    try {
        
        let response = await api.get('/get-scanners');
        
        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occured'
            }
        }
        // return response;
        
    } catch (error) {
        
        return {
            status: false,
            // message: error.response.data.message
        }
        // console.log(error.response.data);
        
        
    }
    
}

export const getScannerConfigs = async() => {
    
    try {
        
        let response = await api.get('/get-scan-configs');
        
        if(response){
            return response.data
        }else{
            return {
                status: false,
                message: 'An error occured'
            }
        }
        // return response;
        
    } catch (error) {
        
        return {
            status: false,
            // message: error.response.data.message
        }
        // console.log(error.response.data);
        
        
    }
    
}